let deviceType = undefined;

const getDevice = () => {
    // If deviceType is already set, return that.
    if (deviceType !== undefined) {
        return deviceType;
    }

    // Otherwise if the corresponding handlers exists in the window object
    if (typeof window !== "undefined") {
        if (typeof window.androidhandler !== "undefined") {
            deviceType = "android";
        } else if (typeof window.ioshandler !== "undefined") {
            deviceType = "ios";
        } else {
            deviceType = null;
        }
    } else {
        deviceType = null;
    }
    
    return deviceType
}

const isMobileDevice = () => {
    return isAndroid() || isIOS();
}

const isAndroid = () =>  getDevice() === "android"
const isIOS = () => getDevice() === "ios"

module.exports = {
    isMobileDevice,
    isAndroid,
    isIOS
}